<template>
	<!-- Global Banners Teleport area -->
	<div id="global-banners"></div>
	<div class="app" v-if="loadedUser">
		<div class="sidebar">
			<sidebar />
		</div>
		<div class="app-content">
			<div class="m-2" style="font-size: smaller" v-show="hasRvlBanner">
				<rvl-migration-banner ref="rvlMigrationBanner" />
			</div>
			<navbar @is-ready="() => (navbarReady = true)" />

			<max-properties-banner />
			<scaling-action-required />

			<slot v-if="navbarReady" />
		</div>

		<modal-global-search />

		<chat-launcher v-if="showZendesk" />
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import AuthService from "@/services/Auth.service";
import { useRoute } from "vue-router";
import { useDeviceStore } from "@/store/device";
import { useConsoleConfig } from "@/plugins/client-name/client-name.plugin";

import MaxPropertiesBanner from "./components/max-properties-banner/max-properties-banner.vue";
import Sidebar from "./components/sidebar/sidebar.vue";
import Navbar from "./components/navbar/navbar.vue";
import ModalGlobalSearch from "./components/global-search/modal-global-search.vue";
import RvlMigrationBanner from "./components/rvl-migration-banner/rvl-migration-banner.vue";
import ScalingActionRequired from "./components/scaling-action-required/scaling-action-required.vue";
import ChatLauncher from "./components/chat-launcher/zendesk.vue";

const route = useRoute();
const deviceStore = useDeviceStore();
const { enableSupport } = useConsoleConfig();

const navbarReady = ref(false); // this is needed because of demo account to load the navbar with <div id="customNavbarTitle">
const loadedUser = ref(false);

onMounted(async () => {
	try {
		await AuthService.getUserInfo();
		loadedUser.value = true;
	} catch {
		loadedUser.value = true;
	}
});

const hasRvlBanner = computed(() => {
	return deviceStore.oldRvlEquipments?.length;
});

const showZendesk = computed(() => {
	return route.name !== "box-v1-dashboard" && enableSupport.value;
});
</script>

<style lang="scss" scoped>
.app {
	overflow: hidden;
	display: flex;
	height: 100vh;
	background-color: $background;

	.sidebar {
		display: flex;
		flex-shrink: 0;
	}

	.app-content {
		background-color: $background;
		flex: 1 1 0%;
		overflow-x: auto;
		overflow-y: scroll;

		&:focus {
			outline: 2px solid transparent;
			outline-offset: 2px;
		}
	}
}
</style>
